import { catchError, map, Observable, of } from 'rxjs';
import { Component, ElementRef, inject, OnInit, ViewChild, HostListener } from '@angular/core';
import { CommonModule, UpperCasePipe } from '@angular/common';
import { RouterLink } from '@angular/router';

import { HeadService } from '../../services/head.service';

import { MenuUsedEquipment } from './models/used-equipment.model';

@Component({
  selector: 'app-megamenu-used',
  imports: [UpperCasePipe, CommonModule, RouterLink],
  templateUrl: './megamenu-used.html',
  styleUrl: './megamenu-used.scss',
})
export class MegamenuUsed implements OnInit {
  private headService = inject(HeadService);

  public categoriesUsed$!: Observable<MenuUsedEquipment[]>;
  public isMobile = false;
  @ViewChild('categories') categories!: ElementRef;
  @ViewChild('subcategories') subcategories!: ElementRef;
  @ViewChild('megamenuUsed') megamenu!: ElementRef;
  @ViewChild('megamenuColumns') megamenuColumns!: ElementRef;

  @HostListener('window:resize') onResize() {
    if (typeof window !== 'undefined') {
      if (window.innerWidth > 992) {
        this.isMobile = false;
        this.categories.nativeElement.style.display = '';
        this.subcategories.nativeElement.style.display = '';
      } else {
        this.isMobile = true;
        this.categories.nativeElement.style.display = 'block';
        this.subcategories.nativeElement.style.display = 'none';
      }
    }
  }

  @HostListener('window:scroll') onScroll() {
    const scroll = window.scrollY || document.documentElement.scrollTop;
    if (this.megamenu && !this.isMobile) {
      this.megamenu.nativeElement.style.top =
        scroll > 1 ? `${scroll >= 57 ? 78 : 122 - scroll}px` : '122px';
    }
  }

  ngOnInit(): void {
    this.getCategoriesNew();
    if (typeof window !== 'undefined') {
      this.isMobile = window.innerWidth <= 992;
    }
  }

  getCategoriesNew(): void {
    this.categoriesUsed$ = this.headService.getCategoriesWithSubcategoriesUsedEquipment().pipe(
      map((res) => res ?? []),
      catchError((error) => {
        console.error(error);
        return of([]);
      })
    );
  }

  closeMegaMenu(): void {
    if (!this.isMobile) {
      if (typeof document !== 'undefined') {
        const linkUsed = document.getElementById('linkUsed');
        linkUsed?.classList.remove('opened');
        document.body.classList.remove('lockScroll');
        const megamenu = document.getElementById('megamenuUsed');
        megamenu?.classList.remove('showMegamenu');
        const gradient = document.getElementById('gradientUsed');
        gradient?.classList.remove('showMegamenu');
      }
    }
  }

  showSubcategories(slug: string) {
    if (this.isMobile) {
      this.categories.nativeElement.style.display = 'none';
      this.subcategories.nativeElement.style.display = 'flex';
    }
    const subcategories = Array.from(document.getElementsByClassName('contentSubcategoriesColumn'));
    const categories = Array.from(document.getElementsByClassName('category'));
    subcategories.forEach((subcategory) => {
      if (subcategory.classList.contains('showSubcategory')) {
        subcategory.classList.remove('showSubcategory');
      }
    });
    categories.forEach((subcategory) => {
      if (subcategory.classList.contains('activeCategory')) {
        subcategory.classList.remove('activeCategory');
      }
    });
    document.getElementById(`used-${slug}`)?.classList.add('showSubcategory');
    document.getElementById('category-' + slug)?.classList.add('activeCategory');
  }

  hideSubcategories(): void {
    this.categories.nativeElement.style.display = 'flex';
    this.subcategories.nativeElement.style.display = 'none';
  }

  hideCategories(): void {
    if (typeof window !== 'undefined') {
      const megamenu = document.getElementById('megamenuUsed');
      megamenu?.classList.remove('showMegamenu');
    }
  }

  checkIsMegaMenuOnHover(): void {
    setTimeout(() => {
      if (typeof window !== 'undefined') {
        if (window.innerWidth > 992) {
          if (!this.megamenuColumns.nativeElement.matches(':hover')) {
            document.body.classList.remove('lockScroll');
            const linkUsed = document.getElementById('linkUsed');
            linkUsed?.classList.remove('opened');
            const megamenu = document.getElementById('megamenuUsed');
            megamenu?.classList.remove('showMegamenu');
            const gradient = document.getElementById('gradientUsed');
            gradient?.classList.remove('showMegamenu');
          }
        }
      }
    }, 100);
  }

  closeAll(): void {
    if (typeof document !== 'undefined') {
      this.categories.nativeElement.style.display = 'flex';
      this.subcategories.nativeElement.style.display = 'none';
      document.body.classList.remove('lockScroll');
      const megamenu = document.getElementById('megamenuUsed');
      megamenu?.classList.remove('showMegamenu');
      const menu = document.querySelector('#mainMenu.navTracsa .contentLinksNav') as HTMLElement;
      if (menu.classList.contains('opened')) {
        menu.classList.remove('opened');
      }
      menu.style.display = '';
      const menuMobileBtn = document.querySelector('.menuBtnMobile') as HTMLElement;
      if (menuMobileBtn.classList.contains('active')) {
        menuMobileBtn.classList.remove('active');
      }
    }
  }
}
